import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDashboard } from "store/services/dashboard/dashboard";

export const GetDashboardAction = createAsyncThunk(
  "dashboard/getDashboardData",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await getDashboard(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
